import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromRoot from '../../../../../../../../../../state/app.state';
import { DailyReportService } from '../../../../daily-report.service';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { CommonService } from '../../../../../../../../../../shared/services/common.service';
import { ChangeIssueStatusRequest } from '../../../../../../../../core/projects.actions';
import { takeUntil } from 'rxjs/operators';
import { Router } from '@angular/router';

@Component({
    selector: 'app-add-close-comment',
    templateUrl: './add-close-comment.component.html',
    styleUrls: ['./add-close-comment.component.scss'],
    standalone: false
})
export class AddCloseCommentComponent implements OnInit, OnDestroy {
  form: FormGroup = new FormGroup({
    comment: new FormControl({ value: '', disabled: false }),
  });
  errorMessages = {};
  errorMessageMap = {
    comment: {
      required: 'This field is required.',
    },
  };
  changeIssueStatusRequestPayload: any;
  comments: any;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private router: Router,
    private store: Store<fromRoot.State>,
    private dailyReportService: DailyReportService,
    private commonService: CommonService,
    public dialogRef: MatDialogRef<AddCloseCommentComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    if (data) {
      this.changeIssueStatusRequestPayload = data.changeIssueStatusRequestPayload;
    }
  }

  ngOnInit() {
    if (this.data.comments) {
      this.form.patchValue({
        comment: this.data.comments,
      }, { emitEvent: false });
    }
    this.commonService.closeDialog
      .pipe(takeUntil(this.onDestroy))
      .subscribe(() => {
        this.dialogRef.close();

        this.router.navigate([], {
          queryParams: {
            selectedId: null,
          },
          queryParamsHandling: 'merge',
        });
      });
  }

  save() {
    const { comment } = this.form.getRawValue();
    const payload = {
      ...this.changeIssueStatusRequestPayload,
      comment,
    };

    this.store.dispatch(ChangeIssueStatusRequest({ payload }));
  }

  close() {
    this.dialogRef.close();
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField)),
    };
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
